module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_4.689281ca49ed12ed2a50d21d5fc3ead7.png";